import { render, staticRenderFns } from "./moreShelf.vue?vue&type=template&id=2f379b5e&scoped=true&"
import script from "./moreShelf.vue?vue&type=script&lang=js&"
export * from "./moreShelf.vue?vue&type=script&lang=js&"
import style0 from "./moreShelf.vue?vue&type=style&index=0&id=2f379b5e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f379b5e",
  null
  
)

export default component.exports